module.exports = __webpack_public_path__ + "img/1.239bffed.jpg";